import { cn } from '@antimatterhq/ui/lib/utils';

export type PreProps = {
  size?: Size;
  bold?: boolean;
  semiBold?: boolean;
} & React.HTMLAttributes<HTMLPreElement>;

export const Pre = ({
  children,
  className,
  size,
  bold,
  semiBold,
  ...props
}: PreProps) => {
  return (
    <pre
      className={cn(
        'text-grey-800 dark:text-grey-100',
        (!size || size === 'sm') && 'text-sm',
        size === 'base' && 'text-base',
        size === 'lg' && 'text-lg',
        bold && 'font-bold',
        semiBold && 'font-semibold',
        className,
      )}
      {...props}
    >
      {children}
    </pre>
  );
};
